import React from "react";
import styles from "./BottomActions.module.css";

interface Props {
  subtotal: string;
  hasOptimisticItems?: boolean;
  handleNavigate: (path: string) => void;
  toggleMiniCart: () => void;
}

const BottomActions: React.FC<Props> = ({
  subtotal,
  hasOptimisticItems = false,
  handleNavigate,
  toggleMiniCart,
}) => {
  const handleGoToCart = () => {
    toggleMiniCart();
    handleNavigate("/cart");
  };

  return (
    <div className={styles.container}>
      <div className={styles.subtotalContainer}>
        <span className={styles.subtotalLabel}>Subtotal:</span>
        <span className={styles.subtotalValue}>{subtotal}</span>
      </div>

      <div className={styles.buttonsContainer}>
        <button
          className="buttonMain"
          onClick={handleGoToCart}
          aria-label="Ver mi carrito"
        >
          Ver mi carrito
        </button>
      </div>
    </div>
  );
};

export default BottomActions;
